import React from "react";
import { Dropdown } from "../../common/components/dropdownSelect";
import { formGroup } from "../../common/components/formGroup";
import { TipoSplit } from "../../generated";
const DropdownList = Dropdown<TipoSplit>();

export const TipiSplit = [
    TipoSplit.Mono,
    TipoSplit.Dual,
    TipoSplit.Multi,
];

export function GetTipoSplitDescription(type: TipoSplit) {
    switch (type) {
        case TipoSplit.Mono:
            return "Mono split";
        case TipoSplit.Dual:
            return "Dual split";
        case TipoSplit.Multi:
            return "Multi split";
        default:
            return "";
    }
}

interface Props {
    value: TipoSplit | null,
    onChange: (type: TipoSplit | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
}
class __TipoSplitSelector extends React.PureComponent<Props> {

    render() {
        const { onChange, value, error, label, onBlur, onFocus } = this.props;
        return <DropdownList
            label={label}
            allowNull
            data={TipiSplit}
            textField={x => GetTipoSplitDescription(x)}
            onSelect={onChange}
            value={value}
            error={error}
            onBlur={onBlur}
            onFocus={onFocus}
        />;
    }
}
export default formGroup(__TipoSplitSelector)

